import request from '../../services/request.service';
import config from '../../config';

export const GET_TEAMS_AND_USERS = 'GET_TEAMS_AND_USERS';
export const GET_TEAMS_AND_USERS_SUCCESS = 'GET_TEAMS_AND_USERS_SUCCESS';
export const GET_TEAMS_AND_USERS_FAIL = 'GET_TEAMS_AND_USERS_FAIL';

export const SAVE_USERS_TEAMS = 'SAVE_USERS_TEAMS';
export const SAVE_USERS_TEAMS_SUCCESS = 'SAVE_USERS_TEAMS_SUCCESS';
export const SAVE_USERS_TEAMS_FAIL = 'SAVE_USERS_TEAMS_FAIL';

export const UPDATE_USERS_ACCESSES = 'UPDATE_USERS_ACCESSES';
export const UPDATE_USERS_ACCESSES_SUCCESS = 'UPDATE_USERS_ACCESSES_SUCCESS';
export const UPDATE_USERS_ACCESSES_FAIL = 'UPDATE_USERS_ACCESSES_FAIL';

export const GET_HWR_USERS = 'GET_HWR_USERS';
export const GET_HWR_USERS_SUCCESS = 'GET_HWR_USERS_SUCCESS';
export const GET_HWR_USERS_FAIL = 'GET_HWR_USERS_FAIL';

export const DELETE_HWR_USER = 'DELETE_HWR_USER';
export const DELETE_HWR_USER_SUCCESS = 'DELETE_HWR_USER_SUCCESS';
export const DELETE_HWR_USER_FAIL = 'DELETE_HWR_USER_FAIL';

export const CREATE_HWR_USER = 'CREATE_HWR_USER';
export const CREATE_HWR_USER_SUCCESS = 'CREATE_HWR_USER_SUCCESS';
export const CREATE_HWR_USER_FAIL = 'CREATE_HWR_USER_FAIL';

export const UPDATE_HWR_USER = 'UPDATE_HWR_USER';
export const UPDATE_HWR_USER_SUCCESS = 'UPDATE_HWR_USER_SUCCESS';
export const UPDATE_HWR_USER_FAIL = 'UPDATE_HWR_USER_FAIL';

export const UPDATE_FLM = 'UPDATE_FLM';
export const UPDATE_FLM_SUCCESS = 'UPDATE_FLM_SUCCESS';
export const UPDATE_FLM_FAIL = 'UPDATE_FLM_FAIL';

const USERNAME_TO_SKIP = 'devadmin';

export function getTeamsAndUsers() {
  return async dispatch => {
    dispatch({
      type: GET_TEAMS_AND_USERS,
    });

    try {
      const [teamsResponse, usersWithRolesResponse] = await Promise.all([
        request(config.admin.teams),
        request(config.admin.getUsersWithRoles),
      ]);

      const teams = teamsResponse.body.filter(team => team.editableOnAdminPage);
      const usersWithRoles = usersWithRolesResponse.body.response.filter(
        user => user.username && user.externalEmail && user.username !== USERNAME_TO_SKIP,
      );

      dispatch({
        type: GET_TEAMS_AND_USERS_SUCCESS,
        teams,
        usersWithRoles,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: GET_TEAMS_AND_USERS_FAIL,
      });
    }
  };
}

export function saveUsersRoles(pairs) {
  return async (dispatch, getState) => {
    dispatch({
      type: SAVE_USERS_TEAMS,
    });

    try {
      const { usersWithRoles, teams } = getState().admin;

      await request(config.admin.saveUsersRoles, {
        method: 'POST',
        body: { pairs },
      });

      const updates = pairs.reduce((acc, { userId, teamId, assigned }) => {
        const teamName = teams.find(({ id }) => id === teamId).name;
        if (!acc[userId]) {
          acc[userId] = {};
        }
        acc[userId][teamName] = assigned;
        return acc;
      }, {});

      const updatedUsersWithRoles = usersWithRoles.map(user => {
        if (updates[user.id] !== undefined) {
          return { ...user, tms: { ...user.tms, ...updates[user.id] } };
        }
        return user;
      });

      dispatch({
        type: SAVE_USERS_TEAMS_SUCCESS,
        usersWithRoles: updatedUsersWithRoles,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: SAVE_USERS_TEAMS_FAIL,
      });
    }
  };
}

export function updateUsersAccess(accesses) {
  return async (dispatch, getState) => {
    dispatch({
      type: UPDATE_USERS_ACCESSES,
    });

    try {
      const { usersWithRoles } = getState().admin;

      await request(config.admin.updateUsersAccesses, {
        method: 'POST',
        body: { accesses },
      });

      const updatedUsersWithRoles = usersWithRoles.map(user => {
        if (accesses[user.id] !== undefined) {
          return { ...user, hasAccessToSASC: accesses[user.id] };
        }
        return user;
      });

      dispatch({
        type: UPDATE_USERS_ACCESSES_SUCCESS,
        usersWithRoles: updatedUsersWithRoles,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: UPDATE_USERS_ACCESSES_FAIL,
      });
    }
  };
}

export function getHWRUsers() {
  return async dispatch => {
    dispatch({
      type: GET_HWR_USERS,
    });

    try {
      const hwrUsersResponse = await request(config.admin.hwrUsers);

      dispatch({
        type: GET_HWR_USERS_SUCCESS,
        hwrUsers: hwrUsersResponse.body,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: GET_HWR_USERS_FAIL,
      });
    }
  };
}

export function createHwrUser(userData) {
  return async dispatch => {
    dispatch({
      type: CREATE_HWR_USER,
    });

    try {
      const response = await request(config.admin.hwrUsers, { method: 'POST', body: userData });

      dispatch({
        type: CREATE_HWR_USER_SUCCESS,
        newUser: response.body,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: CREATE_HWR_USER_FAIL,
      });
    }
  };
}

export function updateHwrUser(userId, userData) {
  return async dispatch => {
    dispatch({
      type: UPDATE_HWR_USER,
    });

    try {
      const url = `${config.admin.updateHwrUser}?where=${window.encodeURIComponent(JSON.stringify({ id: userId }))}`;
      const response = await request(url, { method: 'POST', body: userData });

      dispatch({
        type: UPDATE_HWR_USER_SUCCESS,
        userData: response.body,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: UPDATE_HWR_USER_FAIL,
      });
    }
  };
}

export function deleteHwrUser(userId) {
  return async dispatch => {
    dispatch({
      type: DELETE_HWR_USER,
    });

    try {
      await request(config.admin.hwrUser(userId), { method: 'DELETE' });

      dispatch({
        type: DELETE_HWR_USER_SUCCESS,
        userId,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: DELETE_HWR_USER_FAIL,
      });
    }
  };
}

export function updateFlm(update) {
  return async dispatch => {
    dispatch({
      type: UPDATE_FLM,
    });

    try {
      const response = await request(config.admin.updateFlm, { method: 'POST', body: { update } });

      dispatch({
        type: UPDATE_FLM_SUCCESS,
      });

      return response.body.nModified;
    } catch (err) {
      console.log(err);
      dispatch({
        type: UPDATE_FLM_FAIL,
      });
    }
  };
}
